import AuthGuard from '../components/AuthGuard';
import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { useNavigate } from 'react-router-dom';

export default function SellHistoryPage() {
  const navigate = useNavigate();
  const [rows, setRows] = useState<any[]>([]);
  useEffect(() => { api.get('/sell/history').then(({ data }) => setRows(Array.isArray(data) ? data : [])).catch(() => setRows([])); }, []);
  const label = (t: string) => ({ dangzheng: '党政钱包', buzhu: '补助资金', cash: '现金资产' }[t] ?? '支票资产');
  const statusText = (s: string) => s === 'approved' ? '已通过' : s === 'rejected' ? '已拒绝' : '审核中';
  const statusClass = (s: string) => s === 'approved' ? 'bg-green-200 text-green-700' : s === 'rejected' ? 'bg-red-200 text-red-700' : 'bg-gray-200 text-gray-700';
  return (
    <div
      className="max-w-md mx-auto min-h-screen"
      style={{
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top center',
        backgroundColor: '#f8f3ec',
      }}
    >
      <AuthGuard />
      {/* Header */}
      <div className="relative pt-4 px-4">
        <button
          onClick={() => navigate(-1)}
          className="w-8 h-8 flex items-center justify-center rounded-full bg-black/20 text-white mb-2 relative z-10"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
        </button>
        <div className="flex flex-col items-center gap-3 justify-center relative mt-[-40px]">
          <h4>提现记录</h4>
        </div>
      </div>


      <div className="mx-auto max-w-md px-4 mt-5">
        <div className="mx-auto max-w-md px-4">
          <div className="mt-5 space-y-3">
            {rows.map((r, idx) => (
              <div key={idx} className="rounded-2xl bg-white p-3 shadow">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-sm">{label(r.wallet_type)}</div>
                    <div className="text-[12px] text-gray-500">{new Date(r.created_at).toLocaleString()}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-[#c8a676]">-{Number(r.amount ?? 0).toFixed(0)}</div>
                    <div className={`mt-1 inline-block rounded px-2 py-1 text-[12px] ${statusClass(r.status)}`}>{statusText(r.status)}</div>
                  </div>
                </div>
                {r.remark && <div className="mt-2 rounded bg-gray-50 p-2 text-[12px] text-gray-600">备注：{r.remark}</div>}
                {r.wallet_type === 'buzhu' && <div className="mt-2 text-[11px] text-orange-500">大额提现T+3工作日到账</div>}
              </div>
            ))}
            {rows.length === 0 && (<div className="rounded-2xl bg-gray-50 p-6 text-center text-[12px] text-gray-500">暂无记录</div>)}
          </div>
        </div>
      </div>
    </div>
  );
}